import { Icon24InfoStateLicense } from '@care/react-icons';
import { Box, Typography } from '@mui/material';

export const ProviderLicenseVerified = () => {
  return (
    <Box display="flex" alignItems="center">
      <Icon24InfoStateLicense data-testid="providerLicenseVerified" sx={{ mr: 0.5 }} />
      <Typography variant="h4">State license verified</Typography>
    </Box>
  );
};
